export var BackupZeroEtlOrderingStrategy;
(function (BackupZeroEtlOrderingStrategy) {
    BackupZeroEtlOrderingStrategy["BACKUP_ZERO_ETL_ORDERING_STRATEGY_NONE"] = "NONE";
    BackupZeroEtlOrderingStrategy["BACKUP_ZERO_ETL_ORDERING_STRATEGY_SORT"] = "SORT";
    BackupZeroEtlOrderingStrategy["BACKUP_ZERO_ETL_ORDERING_STRATEGY_ZORDER"] = "ZORDER";
})(BackupZeroEtlOrderingStrategy || (BackupZeroEtlOrderingStrategy = {}));
